<div class="flex justify-end mb-4">
  <div
    class="flex bg-white dark:bg-gray-800 rounded-lg p-1 shadow-sm border border-gray-200 dark:border-gray-700"
  >
    <button
      (click)="vistaLista()"
      class="px-4 py-2 text-sm font-medium rounded-md bg-brand-50 dark:bg-brand-900/30 text-brand-600 dark:text-brand-400 shadow-sm"
    >
      Lista
    </button>
    <button
      (click)="vistaKanban()"
      class="px-4 py-2 text-sm font-medium rounded-md text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
    >
      Kanban
    </button>
    <button
      (click)="vistaCalendario()"
      class="px-4 py-2 text-sm font-medium rounded-md text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
    >
      Calendario
    </button>
  </div>
</div>

<div class="space-y-4 overflow-y-auto">
  <!-- Nueva barra de filtros centralizada -->
  <app-task-filters
    (filterChanged)="onFilterChanged($event)"
    (createClicked)="nuevaTarea()"
  />

  <!-- Estado de carga / error / vacío -->
  @if (loading) {
    <div class="text-center py-12 text-gray-500 dark:text-gray-400">
      <svg
        class="animate-spin mx-auto w-6 h-6 mb-2 text-brand-500"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
          class="opacity-25"
        ></circle>
        <path
          fill="currentColor"
          class="opacity-75"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>
      Cargando tareas…
    </div>
  } @else if (error) {
    <div
      class="p-4 rounded-lg bg-error-50 dark:bg-error-900/20 border border-error-200 dark:border-error-800 text-sm text-error-700 dark:text-error-300"
    >
      {{ error }}
    </div>
  } @else {
    <!-- Encabezado: select all + total. INC 24/38: orden compuesto fijo
         (urgentes primero y, dentro de cada nivel, modificación más reciente). -->
    <div
      class="flex items-center justify-end flex-wrap gap-3 px-2 pt-3 text-sm text-gray-500 dark:text-gray-400"
    >
      <span>{{ globalTotalElements }} tareas en total</span>
    </div>

    <!-- INC 38: tabla única (sin fragmentar por bloques de fecha) -->

    @if (!loading) {
      <div
        class="max-w-full overflow-x-auto custom-scrollbar rounded-xl overflow-y-visible"
      >
        @if (!tasks) {
          <div
            class="flex flex-col items-center gap-2 p-2 text-gray-500 dark:text-gray-400 rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/3"
          >
            <svg
              class="w-12 h-12"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
              ></path>
            </svg>
            <span>No hay tareas registradas</span>
            <button
              (click)="nuevaTarea()"
              class="mt-3 px-4 py-2 text-sm rounded-lg bg-brand-500 text-white hover:bg-brand-600"
            >
              Crear primera tarea
            </button>
          </div>
        } @else {
          <!--Root Table header -->
          <table class="min-w-full">
            <thead
              class="border-b bg-white border-gray-100 text-theme-xs font-medium uppercase text-gray-500 ddark:border-white/5 dark:bg-white/3"
            >
              <tr class="border border-gray-100 dark:border-white/5">
                <th class="px-5 py-3 w-12 flex justify-start">
                  <input
                    type="checkbox"
                    [checked]="allSelected"
                    (change)="toggleAll()"
                  />
                </th>
                <th class="px-5 py-3 w-12 text-start">
                  <span>TITULO / DESCRIPCIÓN</span>
                </th>
                <th class="px-5 py-3 w-12 text-start">
                  <span>TIPO</span>
                </th>
                <th class="px-5 py-3 w-12 text-start">
                  <span>PRIORIDAD</span>
                </th>
                <th class="px-5 py-3 w-12 text-start">
                  <span>ESTADO</span>
                </th>
                <th class="px-5 py-3 w-12 text-start">
                  <span>VENCIMIENTO</span>
                </th>
                <th class="px-5 py-3 w-12 text-start">
                  <span>RESPONSABLE</span>
                </th>
                <th class="px-5 py-3 w-12 text-center rounded-tr-xl">
                  <span>ACCIONES</span>
                </th>
              </tr>
            </thead>
            <tbody
              class="border-b bg-white border-gray-100 text-theme-xs font-medium uppercase text-gray-500 dark:border-white/5 dark:bg-white/3"
            >
              @for (task of tasks; track trackById($index, task)) {
                <tr
                  class="border border-gray-100 dark:border-white/5"
                  [class.dark:bg-brand-50/20]="task.selected"
                  [class.bg-gray-200]="task.selected"
                >
                  <td class="px-5 py-3 w-12">
                    <input
                      type="checkbox"
                      [checked]="
                        task.id != null && selectedTasksMap.has(task.id)
                      "
                      (change)="toggleOne(task)"
                    />
                  </td>
                  <td class="px-5 py-3 text-start">
                    <div class="flex flex-col gap-1">
                      <div class="flex gap-2">
                        @if (task.subtasks?.length !== 0) {
                          <button (click)="task.isOpen = !task.isOpen">
                            @if (!task.isOpen) {
                              <svg
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                class="w-3.5 h-3.5 transition-transform"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M9 5l7 7-7 7"
                                ></path>
                              </svg>
                            } @else {
                              <svg
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                class="w-3.5 h-3.5 transition-transform rotate-90"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M9 5l7 7-7 7"
                                ></path>
                              </svg>
                            }
                          </button>
                        }
                        <button
                          (click)="abrirDetalle(task.id!)"
                          class="text-sm font-semibold text-gray-900 dark:text-white hover:text-brand-600 dark:hover:text-brand-400 transition-colors text-left truncate"
                          [class.ml-0.5]="task.subtasks?.length === 0"
                        >
                          {{ task.title }}
                        </button>
                      </div>
                      @if (task.description) {
                        <p
                          class="ml-0.5 text-xs text-gray-500 dark:text-gray-400 line-clamp-2 leading-relaxed"
                        >
                          {{ task.description }}
                        </p>
                      }
                    </div>
                  </td>
                  <td class="px-5 py-3 text-start">
                    {{ resolveType(task)?.label ?? '-' }}
                  </td>
                  <td class="px-5 py-3 text-start">
                    {{ resolvePriority(task)?.label ?? '-' }}
                  </td>
                  <td class="px-5 py-3¿ text-start">
                    @if (canEditTasks && !isFinished(task)) {
                      <div
                        class="relative inline-block"
                        (click)="$event.stopPropagation()"
                      >
                        <button
                          type="button"
                          (click)="toggleStatusMenu(task, $event)"
                          class="inline-flex items-center gap-1.5 text-[10px] px-2 py-0.5 rounded-md font-bold border dark:bg-gray-800 text-gray-700 dark:text-gray-200 whitespace-nowrap hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                          [style.border-color]="
                            resolveStatus(task)?.color || '#9CA3AF'
                          "
                          title="Cambiar estado"
                        >
                          <span
                            class="w-1.5 h-1.5 rounded-full shrink-0"
                            [style.background-color]="
                              resolveStatus(task)?.color || '#9CA3AF'
                            "
                          ></span>
                          {{ resolveStatus(task)?.label || '—' }}
                          <svg
                            class="w-3 h-3 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </button>
                        @if (statusMenuTaskId === task.id) {
                          <div
                            class="fixed z-dropdown w-48 max-h-64 overflow-y-auto rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg py-1"
                            [style.top.px]="statusMenuPosition.top"
                            [style.left.px]="statusMenuPosition.left"
                          >
                            @for (st of statusOptionsFor(task); track st.id) {
                              <button
                                type="button"
                                (click)="cambiarEstado(task, st)"
                                class="w-full flex items-center gap-2 px-3 py-1.5 text-xs text-left text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <span
                                  class="w-1.5 h-1.5 rounded-full shrink-0"
                                  [style.background-color]="
                                    st.color || '#9CA3AF'
                                  "
                                ></span>
                                {{ st.label }}
                              </button>
                            } @empty {
                              <p class="px-3 py-2 text-xs text-gray-400 italic">
                                No hay otros estados.
                              </p>
                            }
                          </div>
                        }
                      </div>
                    } @else if (resolveStatus(task); as status) {
                      <span
                        class="inline-flex items-center gap-1.5 text-[10px] px-2 py-0.5 rounded-md font-bold border dark:bg-gray-800 text-gray-700 dark:text-gray-200 whitespace-nowrap"
                        [style.border-color]="status.color || '#9CA3AF'"
                      >
                        <span
                          class="w-1.5 h-1.5 rounded-full shrink-0"
                          [style.background-color]="status.color || '#9CA3AF'"
                        ></span>
                        {{ status.label }}
                      </span>
                    } @else {
                      <span class="text-xs text-gray-400 italic">—</span>
                    }
                  </td>
                  <td class="px-5 py-3 w-12 text-start">
                    <span
                      class="text-xs inline-flex items-center gap-1.5"
                      [class.text-error-600]="isOverdue(task)"
                      [class.dark:text-error-400]="isOverdue(task)"
                      [class.font-bold]="isOverdue(task)"
                      [class.text-gray-500]="!isOverdue(task)"
                      [class.dark:text-gray-400]="!isOverdue(task)"
                    >
                      <svg
                        class="w-3 h-3"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2.5"
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      {{ formatDue(task) }}
                    </span>
                  </td>
                  <td class="px-5 py-3 w-12 text-start">
                    {{ getOwnerName(task.intIdUserOwner) }}
                  </td>
                  <td class="px-5 py-3 w-12">
                    <div class="flex items-start justify-center">
                      @if (!isFinished(task)) {
                        <!-- INC 35 y 36: no permitir re-completar o re-cancelar; INC 26: abre prompt con nota opcional -->

                        <button
                          (click)="abrirCompletarDialog(task)"
                          *appHasPermission="'tasks:edit'"
                          title="Completar"
                          class="p-2 rounded-lg hover:text-success-600 hover:bg-success-50 dark:hover:bg-success-900/20"
                        >
                          <svg
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        </button>

                        <button
                          (click)="posponer1Dia(task)"
                          *appHasPermission="'tasks:edit'"
                          title="Posponer 1 día"
                          class="p-2 rounded-lg hover:text-warning-600 hover:bg-warning-50 dark:hover:bg-warning-900/20"
                        >
                          <svg
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                        </button>

                        <button
                          (click)="cancelarTarea(task)"
                          *appHasPermission="'tasks:edit'"
                          title="Cancelar"
                          class="p-2 rounded-lg hover:text-error-600 hover:bg-error-50 dark:hover:bg-error-900/20"
                        >
                          <svg
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                            />
                          </svg>
                        </button>

                        <!-- INC 30: reasignar con motivo -->
                        <button
                          (click)="reasignarTarea(task)"
                          *appHasPermission="'tasks:edit'"
                          title="Reasignar"
                          class="p-2 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-900/20 hover:text-purple-600 dark:hover:text-purple-400"
                        >
                          <svg
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                            />
                          </svg>
                        </button>
                      } @else {
                        <button
                          (click)="reabrir(task)"
                          *appHasPermission="'tasks:edit'"
                          title="Reabrir"
                          class="p-2 rounded-lg hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700"
                        >
                          <svg
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                            />
                          </svg>
                        </button>
                      }
                      <button
                        (click)="editarTarea(task.id!)"
                        *appHasPermission="'tasks:edit'"
                        title="Editar"
                        class="p-2 rounded-lg hover:text-brand-500 hover:bg-brand-50 dark:hover:bg-brand-900/20"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          />
                        </svg>
                      </button>
                      <button
                        (click)="eliminarTarea(task)"
                        *appHasPermission="'tasks:delete'"
                        title="Eliminar"
                        class="p-2 rounded-lg hover:text-error-600 hover:bg-error-50 dark:hover:bg-error-900/20"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"
                          />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
                @if (task.subtasks && task.isOpen) {
                  @for (
                    subtask of task.subtasks;
                    track trackById($index, subtask)
                  ) {
                    <tr
                      class="border border-gray-100 dark:border-white/5"
                      [class.dark:bg-brand-50/20]="subtask.selected"
                      [class.bg-gray-200]="subtask.selected"
                    >
                      <td class="px-5 py-3 w-12">
                        <input
                          type="checkbox"
                          [checked]="
                            subtask.id != null &&
                            selectedTasksMap.has(subtask.id)
                          "
                          (change)="toggleOne(subtask)"
                        />
                      </td>
                      <td class="pl-8 px-5 py-3 text-start">
                        <div class="flex flex-col gap-1">
                          <div class="flex gap-2">
                            @if (subtask.subtasks?.length !== 0) {
                              <button
                                (click)="subtask.isOpen = !subtask.isOpen"
                              >
                                @if (!subtask.isOpen) {
                                  <svg
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    class="w-3.5 h-3.5 transition-transform"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M9 5l7 7-7 7"
                                    ></path>
                                  </svg>
                                } @else {
                                  <svg
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    class="w-3.5 h-3.5 transition-transform rotate-90"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M9 5l7 7-7 7"
                                    ></path>
                                  </svg>
                                }
                              </button>
                            }
                            <button
                              (click)="abrirDetalle(subtask.id!)"
                              class="text-sm font-semibold text-gray-900 dark:text-white hover:text-brand-600 dark:hover:text-brand-400 transition-colors text-left truncate"
                              [class.ml-0.5]="!subtask.subtasks"
                            >
                              {{ subtask.title }}
                            </button>
                          </div>
                          @if (subtask.description) {
                            <p
                              class="ml-0.5 text-xs text-gray-500 dark:text-gray-400 line-clamp-2 leading-relaxed"
                            >
                              {{ subtask.description }}
                            </p>
                          }
                        </div>
                      </td>
                      <td class="px-5 py-3 text-start">
                        {{ resolveType(subtask)?.label ?? '-' }}
                      </td>
                      <td class="px-5 py-3 text-start">
                        {{ resolvePriority(subtask)?.label ?? '-' }}
                      </td>
                      <td class="px-5 py-3¿ text-start">
                        @if (canEditTasks && !isFinished(subtask)) {
                          <div
                            class="relative inline-block"
                            (click)="$event.stopPropagation()"
                          >
                            <button
                              type="button"
                              (click)="toggleStatusMenu(subtask, $event)"
                              class="inline-flex items-center gap-1.5 text-[10px] px-2 py-0.5 rounded-md font-bold border dark:bg-gray-800 text-gray-700 dark:text-gray-200 whitespace-nowrap hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              [style.border-color]="
                                resolveStatus(subtask)?.color || '#9CA3AF'
                              "
                              title="Cambiar estado"
                            >
                              <span
                                class="w-1.5 h-1.5 rounded-full shrink-0"
                                [style.background-color]="
                                  resolveStatus(subtask)?.color || '#9CA3AF'
                                "
                              ></span>
                              {{ resolveStatus(subtask)?.label || '—' }}
                              <svg
                                class="w-3 h-3 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M19 9l-7 7-7-7"
                                />
                              </svg>
                            </button>
                            @if (statusMenuTaskId === subtask.id) {
                              <div
                                class="fixed z-dropdown w-48 max-h-64 overflow-y-auto rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg py-1"
                                [style.top.px]="statusMenuPosition.top"
                                [style.left.px]="statusMenuPosition.left"
                              >
                                @for (
                                  st of statusOptionsFor(subtask);
                                  track st.id
                                ) {
                                  <button
                                    type="button"
                                    (click)="cambiarEstado(subtask, st)"
                                    class="w-full flex items-center gap-2 px-3 py-1.5 text-xs text-left text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
                                  >
                                    <span
                                      class="w-1.5 h-1.5 rounded-full shrink-0"
                                      [style.background-color]="
                                        st.color || '#9CA3AF'
                                      "
                                    ></span>
                                    {{ st.label }}
                                  </button>
                                } @empty {
                                  <p
                                    class="px-3 py-2 text-xs text-gray-400 italic"
                                  >
                                    No hay otros estados.
                                  </p>
                                }
                              </div>
                            }
                          </div>
                        } @else if (resolveStatus(subtask); as status) {
                          <span
                            class="inline-flex items-center gap-1.5 text-[10px] px-2 py-0.5 rounded-md font-bold border dark:bg-gray-800 text-gray-700 dark:text-gray-200 whitespace-nowrap"
                            [style.border-color]="status.color || '#9CA3AF'"
                          >
                            <span
                              class="w-1.5 h-1.5 rounded-full shrink-0"
                              [style.background-color]="
                                status.color || '#9CA3AF'
                              "
                            ></span>
                            {{ status.label }}
                          </span>
                        } @else {
                          <span class="text-xs text-gray-400 italic">—</span>
                        }
                      </td>
                      <td class="px-5 py-3 w-12 text-start">
                        <span
                          class="text-xs inline-flex items-center gap-1.5"
                          [class.text-error-600]="isOverdue(subtask)"
                          [class.dark:text-error-400]="isOverdue(subtask)"
                          [class.font-bold]="isOverdue(subtask)"
                          [class.text-gray-500]="!isOverdue(subtask)"
                          [class.dark:text-gray-400]="!isOverdue(subtask)"
                        >
                          <svg
                            class="w-3 h-3"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2.5"
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                          {{ formatDue(subtask) }}
                        </span>
                      </td>
                      <td class="px-5 py-3 w-12 text-start">
                        {{ getOwnerName(subtask.intIdUserOwner) }}
                      </td>
                      <td class="px-5 py-3 w-12">
                        <div class="flex items-start justify-center">
                          @if (!isFinished(subtask)) {
                            <!-- INC 35 y 36: no permitir re-completar o re-cancelar; INC 26: abre prompt con nota opcional -->

                            <button
                              (click)="abrirCompletarDialog(subtask)"
                              *appHasPermission="'tasks:edit'"
                              title="Completar"
                              class="p-2 rounded-lg hover:text-success-600 hover:bg-success-50 dark:hover:bg-success-900/20"
                            >
                              <svg
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M5 13l4 4L19 7"
                                />
                              </svg>
                            </button>

                            <button
                              (click)="posponer1Dia(subtask)"
                              *appHasPermission="'tasks:edit'"
                              title="Posponer 1 día"
                              class="p-2 rounded-lg hover:text-warning-600 hover:bg-warning-50 dark:hover:bg-warning-900/20"
                            >
                              <svg
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            </button>

                            <button
                              (click)="cancelarTarea(subtask)"
                              *appHasPermission="'tasks:edit'"
                              title="Cancelar"
                              class="p-2 rounded-lg hover:text-error-600 hover:bg-error-50 dark:hover:bg-error-900/20"
                            >
                              <svg
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                                />
                              </svg>
                            </button>

                            <!-- INC 30: reasignar con motivo -->
                            <button
                              (click)="reasignarTarea(subtask)"
                              *appHasPermission="'tasks:edit'"
                              title="Reasignar"
                              class="p-2 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-900/20 hover:text-purple-600 dark:hover:text-purple-400"
                            >
                              <svg
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                />
                              </svg>
                            </button>
                          } @else {
                            <button
                              (click)="reabrir(subtask)"
                              *appHasPermission="'tasks:edit'"
                              title="Reabrir"
                              class="p-2 rounded-lg hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700"
                            >
                              <svg
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                />
                              </svg>
                            </button>
                          }
                          <button
                            (click)="editarTarea(subtask.id!)"
                            *appHasPermission="'tasks:edit'"
                            title="Editar"
                            class="p-2 rounded-lg hover:text-brand-500 hover:bg-brand-50 dark:hover:bg-brand-900/20"
                          >
                            <svg
                              class="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              />
                            </svg>
                          </button>
                          <button
                            (click)="eliminarTarea(subtask)"
                            *appHasPermission="'tasks:delete'"
                            title="Eliminar"
                            class="p-2 rounded-lg hover:text-error-600 hover:bg-error-50 dark:hover:bg-error-900/20"
                          >
                            <svg
                              class="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"
                              />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                    @if (subtask.subtasks && subtask.isOpen) {
                      @for (
                        subsubtask of subtask.subtasks;
                        track trackById($index, subsubtask)
                      ) {
                        <tr
                          class="border border-gray-100 dark:border-white/5"
                          [class.dark:bg-brand-50/20]="subsubtask.selected"
                          [class.bg-gray-200]="subsubtask.selected"
                        >
                          <td class="px-5 py-3 w-12">
                            <input
                              type="checkbox"
                              [checked]="
                                subsubtask.id != null &&
                                selectedTasksMap.has(subsubtask.id)
                              "
                              (change)="toggleOne(task)"
                            />
                          </td>
                          <td class="pl-16 px-5 py-3 text-start">
                            <div class="flex flex-col gap-1">
                              <div class="flex gap-2">
                                <button
                                  (click)="abrirDetalle(subsubtask.id!)"
                                  class="text-sm font-semibold text-gray-900 dark:text-white hover:text-brand-600 dark:hover:text-brand-400 transition-colors text-left truncate"
                                  [class.ml-0.5]="!subsubtask.subtasks"
                                >
                                  {{ subsubtask.title }}
                                </button>
                              </div>
                              @if (subsubtask.description) {
                                <p
                                  class="ml-0.5 text-xs text-gray-500 dark:text-gray-400 line-clamp-2 leading-relaxed"
                                >
                                  {{ subsubtask.description }}
                                </p>
                              }
                            </div>
                          </td>
                          <td class="px-5 py-3 text-start">
                            {{ resolveType(subsubtask)?.label ?? '-' }}
                          </td>
                          <td class="px-5 py-3 text-start">
                            {{ resolvePriority(subsubtask)?.label ?? '-' }}
                          </td>
                          <td class="px-5 py-3¿ text-start">
                            @if (canEditTasks && !isFinished(subsubtask)) {
                              <div
                                class="relative inline-block"
                                (click)="$event.stopPropagation()"
                              >
                                <button
                                  type="button"
                                  (click)="toggleStatusMenu(subsubtask, $event)"
                                  class="inline-flex items-center gap-1.5 text-[10px] px-2 py-0.5 rounded-md font-bold border dark:bg-gray-800 text-gray-700 dark:text-gray-200 whitespace-nowrap hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                                  [style.border-color]="
                                    resolveStatus(subsubtask)?.color ||
                                    '#9CA3AF'
                                  "
                                  title="Cambiar estado"
                                >
                                  <span
                                    class="w-1.5 h-1.5 rounded-full shrink-0"
                                    [style.background-color]="
                                      resolveStatus(subsubtask)?.color ||
                                      '#9CA3AF'
                                    "
                                  ></span>
                                  {{ resolveStatus(subsubtask)?.label || '—' }}
                                  <svg
                                    class="w-3 h-3 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M19 9l-7 7-7-7"
                                    />
                                  </svg>
                                </button>
                                @if (statusMenuTaskId === subsubtask.id) {
                                  <div
                                    class="fixed z-dropdown w-48 max-h-64 overflow-y-auto rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg py-1"
                                    [style.top.px]="statusMenuPosition.top"
                                    [style.left.px]="statusMenuPosition.left"
                                  >
                                    @for (
                                      st of statusOptionsFor(subsubtask);
                                      track st.id
                                    ) {
                                      <button
                                        type="button"
                                        (click)="cambiarEstado(subsubtask, st)"
                                        class="w-full flex items-center gap-2 px-3 py-1.5 text-xs text-left text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
                                      >
                                        <span
                                          class="w-1.5 h-1.5 rounded-full shrink-0"
                                          [style.background-color]="
                                            st.color || '#9CA3AF'
                                          "
                                        ></span>
                                        {{ st.label }}
                                      </button>
                                    } @empty {
                                      <p
                                        class="px-3 py-2 text-xs text-gray-400 italic"
                                      >
                                        No hay otros estados.
                                      </p>
                                    }
                                  </div>
                                }
                              </div>
                            } @else if (resolveStatus(subsubtask); as status) {
                              <span
                                class="inline-flex items-center gap-1.5 text-[10px] px-2 py-0.5 rounded-md font-bold border dark:bg-gray-800 text-gray-700 dark:text-gray-200 whitespace-nowrap"
                                [style.border-color]="status.color || '#9CA3AF'"
                              >
                                <span
                                  class="w-1.5 h-1.5 rounded-full shrink-0"
                                  [style.background-color]="
                                    status.color || '#9CA3AF'
                                  "
                                ></span>
                                {{ status.label }}
                              </span>
                            } @else {
                              <span class="text-xs text-gray-400 italic"
                                >—</span
                              >
                            }
                          </td>
                          <td class="px-5 py-3 w-12 text-start">
                            <span
                              class="text-xs inline-flex items-center gap-1.5"
                              [class.text-error-600]="isOverdue(subsubtask)"
                              [class.dark:text-error-400]="
                                isOverdue(subsubtask)
                              "
                              [class.font-bold]="isOverdue(subsubtask)"
                              [class.text-gray-500]="!isOverdue(subsubtask)"
                              [class.dark:text-gray-400]="
                                !isOverdue(subsubtask)
                              "
                            >
                              <svg
                                class="w-3 h-3"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2.5"
                                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                />
                              </svg>
                              {{ formatDue(subsubtask) }}
                            </span>
                          </td>
                          <td class="px-5 py-3 w-12 text-start">
                            {{ getOwnerName(subsubtask.intIdUserOwner) }}
                          </td>
                          <td class="px-5 py-3 w-12">
                            <div class="flex items-start justify-center">
                              @if (!isFinished(subsubtask)) {
                                <!-- INC 35 y 36: no permitir re-completar o re-cancelar; INC 26: abre prompt con nota opcional -->

                                <button
                                  (click)="abrirCompletarDialog(subsubtask)"
                                  *appHasPermission="'tasks:edit'"
                                  title="Completar"
                                  class="p-2 rounded-lg hover:text-success-600 hover:bg-success-50 dark:hover:bg-success-900/20"
                                >
                                  <svg
                                    class="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M5 13l4 4L19 7"
                                    />
                                  </svg>
                                </button>

                                <button
                                  (click)="posponer1Dia(subsubtask)"
                                  *appHasPermission="'tasks:edit'"
                                  title="Posponer 1 día"
                                  class="p-2 rounded-lg hover:text-warning-600 hover:bg-warning-50 dark:hover:bg-warning-900/20"
                                >
                                  <svg
                                    class="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                  </svg>
                                </button>

                                <button
                                  (click)="cancelarTarea(subsubtask)"
                                  *appHasPermission="'tasks:edit'"
                                  title="Cancelar"
                                  class="p-2 rounded-lg hover:text-error-600 hover:bg-error-50 dark:hover:bg-error-900/20"
                                >
                                  <svg
                                    class="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                                    />
                                  </svg>
                                </button>

                                <!-- INC 30: reasignar con motivo -->
                                <button
                                  (click)="reasignarTarea(subsubtask)"
                                  *appHasPermission="'tasks:edit'"
                                  title="Reasignar"
                                  class="p-2 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-900/20 hover:text-purple-600 dark:hover:text-purple-400"
                                >
                                  <svg
                                    class="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                    />
                                  </svg>
                                </button>
                              } @else {
                                <button
                                  (click)="reabrir(subsubtask)"
                                  *appHasPermission="'tasks:edit'"
                                  title="Reabrir"
                                  class="p-2 rounded-lg hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700"
                                >
                                  <svg
                                    class="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                    />
                                  </svg>
                                </button>
                              }
                              <button
                                (click)="editarTarea(subsubtask.id!)"
                                *appHasPermission="'tasks:edit'"
                                title="Editar"
                                class="p-2 rounded-lg hover:text-brand-500 hover:bg-brand-50 dark:hover:bg-brand-900/20"
                              >
                                <svg
                                  class="w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                  />
                                </svg>
                              </button>
                              <button
                                (click)="eliminarTarea(subsubtask)"
                                *appHasPermission="'tasks:delete'"
                                title="Eliminar"
                                class="p-2 rounded-lg hover:text-error-600 hover:bg-error-50 dark:hover:bg-error-900/20"
                              >
                                <svg
                                  class="w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"
                                  />
                                </svg>
                              </button>
                            </div>
                          </td>
                        </tr>
                      }
                    }
                  }
                }
              }
            </tbody>
          </table>
        }
      </div>
    }

    <!-- Paginación -->
    <div class="flex items-center justify-between flex-wrap gap-2 pt-2">
      <div
        class="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400"
      >
        Mostrar
        <select
          [(ngModel)]="pageSize"
          (ngModelChange)="onPageSizeChange()"
          class="rounded-md border border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-white px-2 py-1 text-sm"
        >
          @for (s of PAGE_SIZE_OPTIONS; track s) {
            <option [ngValue]="s">{{ s }}</option>
          }
        </select>
        por página
      </div>
      <div class="flex items-center gap-2 text-sm">
        <button
          (click)="changePage(globalPage - 1)"
          [disabled]="globalPage === 0"
          class="px-3 py-1.5 rounded-md border border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-50 text-gray-500 dark:text-gray-400"
        >
          Anterior
        </button>
        <span class="text-gray-600 dark:text-gray-400">
          Página {{ globalPage + 1 }} de {{ globalTotalPages || 1 }}
        </span>
        <button
          (click)="changePage(globalPage + 1)"
          [disabled]="globalPage + 1 >= globalTotalPages"
          class="px-3 py-1.5 rounded-md border border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-50 text-gray-500 dark:text-gray-400"
        >
          Siguiente
        </button>
      </div>
    </div>
  }
</div>

<!-- Bulk toolbar flotante -->
@if (selectedTasksMap.size > 0) {
  <div
    class="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-3 rounded-xl shadow-2xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700"
  >
    <span class="text-sm font-medium text-gray-700 dark:text-gray-200">
      {{ selectedTasksMap.size }} seleccionada(s)
    </span>
    <span class="w-px h-6 bg-gray-200 dark:bg-gray-700"></span>

    <button
      (click)="bulkComplete()"
      class="px-3 py-1.5 text-sm rounded-md bg-success-500 text-white hover:bg-success-600 disabled:opacity-50 disabled:cursor-not-allowed"
      [disabled]="!hasCompletedTerminalStatus"
    >
      Completar
    </button>

    <button
      (click)="openBulkSnooze()"
      class="px-3 py-1.5 text-sm rounded-md bg-warning-500 text-white hover:bg-warning-600"
    >
      Posponer
    </button>

    @if (canBulkReassign) {
      <button
        (click)="openBulkReassign()"
        class="px-3 py-1.5 text-sm rounded-md bg-brand-500 text-white hover:bg-brand-600"
      >
        <svg
          class="w-4 h-4 inline-block mr-1"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
          />
        </svg>
        Reasignar
      </button>
    }
    <button
      (click)="openBulkCancel()"
      class="px-3 py-1.5 text-sm rounded-md bg-gray-500 text-white hover:bg-gray-600"
    >
      Cancelar
    </button>

    <button
      (click)="bulkDelete()"
      class="px-3 py-1.5 text-sm rounded-md bg-error-500 text-white hover:bg-error-600"
    >
      Eliminar
    </button>

    <span class="w-px h-6 bg-gray-200 dark:bg-gray-700"></span>

    <button
      (click)="clearSelection()"
      class="px-2 py-1.5 text-sm text-gray-500 hover:text-gray-700 dark:hover:text-gray-200"
    >
      Limpiar
    </button>
  </div>
}

<!-- Bulk snooze dialog -->
@if (showSnoozeDialog) {
  <div
    class="fixed inset-0 z-drawer flex items-center justify-center bg-black/40"
    (click)="showSnoozeDialog = false"
  >
    <div
      class="bg-white dark:bg-gray-900 rounded-xl shadow-2xl p-6 w-full max-w-md mx-4"
      (click)="$event.stopPropagation()"
    >
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        Posponer tareas
      </h3>
      <div class="grid grid-cols-3 gap-2 mb-4">
        <button
          (click)="applySnoozePreset('TOMORROW')"
          class="px-3 py-2 text-sm rounded-md border"
          [class.border-brand-500]="bulkSnoozePreset === 'TOMORROW'"
          [class.bg-brand-50]="bulkSnoozePreset === 'TOMORROW'"
          [class.dark:bg-brand-900/30]="bulkSnoozePreset === 'TOMORROW'"
          [class.border-gray-300]="bulkSnoozePreset !== 'TOMORROW'"
          [class.dark:border-gray-700]="bulkSnoozePreset !== 'TOMORROW'"
        >
          Mañana
        </button>
        <button
          (click)="applySnoozePreset('IN_3_DAYS')"
          class="px-3 py-2 text-sm rounded-md border"
          [class.border-brand-500]="bulkSnoozePreset === 'IN_3_DAYS'"
          [class.bg-brand-50]="bulkSnoozePreset === 'IN_3_DAYS'"
          [class.dark:bg-brand-900/30]="bulkSnoozePreset === 'IN_3_DAYS'"
          [class.border-gray-300]="bulkSnoozePreset !== 'IN_3_DAYS'"
          [class.dark:border-gray-700]="bulkSnoozePreset !== 'IN_3_DAYS'"
        >
          En 3 días
        </button>
        <button
          (click)="applySnoozePreset('NEXT_WEEK')"
          class="px-3 py-2 text-sm rounded-md border"
          [class.border-brand-500]="bulkSnoozePreset === 'NEXT_WEEK'"
          [class.bg-brand-50]="bulkSnoozePreset === 'NEXT_WEEK'"
          [class.dark:bg-brand-900/30]="bulkSnoozePreset === 'NEXT_WEEK'"
          [class.border-gray-300]="bulkSnoozePreset !== 'NEXT_WEEK'"
          [class.dark:border-gray-700]="bulkSnoozePreset !== 'NEXT_WEEK'"
        >
          Próxima semana
        </button>
      </div>
      <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1"
        >Fecha personalizada</label
      >
      <input
        type="datetime-local"
        [(ngModel)]="bulkSnoozeDate"
        (ngModelChange)="bulkSnoozePreset = 'CUSTOM'"
        class="w-full text-sm rounded-md border border-gray-300 bg-white text-gray-900 dark:bg-gray-800 dark:border-gray-700 dark:text-white px-3 py-2 mb-4"
      />
      <div class="flex justify-end gap-2">
        <button
          (click)="showSnoozeDialog = false"
          class="px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-gray-700"
        >
          Cancelar
        </button>
        <button
          (click)="applyBulkSnooze()"
          class="px-4 py-2 text-sm rounded-md bg-warning-500 text-white"
        >
          Posponer
        </button>
      </div>
    </div>
  </div>
}

<!-- Reassign dialog (single tarea o bulk según reassignTargetTaskId) -->
@if (showReassignDialog) {
  <div
    class="fixed inset-0 z-drawer flex items-center justify-center bg-black/40"
    (click)="closeReassignDialog()"
  >
    <div
      class="bg-white dark:bg-gray-900 rounded-xl shadow-2xl p-6 w-full max-w-md mx-4"
      (click)="$event.stopPropagation()"
    >
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">
        {{
          reassignTargetTaskId != null ? 'Reasignar tarea' : 'Reasignar tareas'
        }}
      </h3>
      @if (reassignTargetTaskId != null) {
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-3 truncate">
          {{ reassignTargetTitle }}
        </p>
      } @else {
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-3">
          {{ selectedTasksMap.size }} tarea(s) seleccionadas
        </p>
      }

      <app-entity-picker
        mode="single"
        label="Nuevo responsable"
        placeholder="Buscar usuario por nombre o email..."
        helperText="La tarea pasará a este usuario."
        [selectedId]="bulkNewOwner?.id ?? null"
        [selectedLabel]="bulkNewOwner?.label ?? null"
        [selectedSublabel]="bulkNewOwner?.sublabel ?? null"
        [searchFn]="searchUser"
        (selectionChange)="onBulkOwnerChange($event)"
      />

      <!-- INC 30: motivo opcional de la reasignación -->
      <label class="block text-xs text-gray-500 dark:text-gray-400 mt-4 mb-1"
        >Motivo (opcional)</label
      >
      <textarea
        [(ngModel)]="bulkReassignReason"
        rows="3"
        placeholder="Ej. el responsable original está de vacaciones"
        class="w-full text-sm rounded-md border border-gray-300 bg-white text-gray-900 placeholder:text-gray-400 dark:bg-gray-800 dark:border-gray-700 dark:text-white px-3 py-2"
      ></textarea>

      @if (reassignWarningMessage) {
        <div
          class="mt-4 p-3 rounded-lg bg-warning-50 border border-warning-200 text-sm text-warning-700 dark:bg-warning-500/10 dark:border-warning-500/20 dark:text-warning-400"
        >
          {{ reassignWarningMessage }}
        </div>
      }

      <div class="flex justify-end gap-2 mt-6">
        <button
          (click)="closeReassignDialog()"
          class="px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-gray-700"
        >
          Cerrar
        </button>
        <button
          (click)="applyReassignDialog()"
          [disabled]="!bulkNewOwner || !!reassignWarningMessage"
          class="px-4 py-2 text-sm rounded-md bg-brand-500 text-white disabled:opacity-50"
        >
          {{
            reassignTargetTaskId != null
              ? 'Reasignar tarea'
              : 'Reasignar tareas'
          }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Complete dialog (single, INC 26 — nota final opcional) -->
@if (showCompleteDialog) {
  <div
    class="fixed inset-0 z-drawer flex items-center justify-center bg-black/40"
    (click)="closeCompleteDialog()"
  >
    <div
      class="bg-white dark:bg-gray-900 rounded-xl shadow-2xl p-6 w-full max-w-md mx-4"
      (click)="$event.stopPropagation()"
    >
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">
        Completar tarea
      </h3>
      <p class="text-sm text-gray-500 dark:text-gray-400 mb-3 truncate">
        {{ completeTargetTitle }}
      </p>
      <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1"
        >Nota final (opcional)</label
      >
      <textarea
        [(ngModel)]="completionNotes"
        rows="3"
        placeholder="Ej. resultado de la gestión, próximos pasos..."
        class="w-full text-sm rounded-md border border-gray-300 bg-white text-gray-900 placeholder:text-gray-400 dark:bg-gray-800 dark:border-gray-700 dark:text-white px-3 py-2 mb-4"
      ></textarea>
      <div class="flex justify-end gap-2">
        <button
          (click)="closeCompleteDialog()"
          class="px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-gray-700"
        >
          Cancelar
        </button>
        <button
          (click)="aplicarCompletar()"
          class="px-4 py-2 text-sm rounded-md bg-success-500 text-white hover:bg-success-600"
        >
          Completar
        </button>
      </div>
    </div>
  </div>
}

<!-- Cancel dialog (single tarea o bulk según cancelTargetTaskId) -->
@if (showCancelDialog) {
  <div
    class="fixed inset-0 z-drawer flex items-center justify-center bg-black/40"
    (click)="closeCancelDialog()"
  >
    <div
      class="bg-white dark:bg-gray-900 rounded-xl shadow-2xl p-6 w-full max-w-md mx-4"
      (click)="$event.stopPropagation()"
    >
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">
        {{ cancelTargetTaskId != null ? 'Cancelar tarea' : 'Cancelar tareas' }}
      </h3>
      @if (cancelTargetTaskId != null) {
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-3 truncate">
          {{ cancelTargetTitle }}
        </p>
      } @else {
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-3">
          {{ selectedTasksMap.size }} tarea(s) seleccionadas
        </p>
      }
      <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1"
        >Motivo</label
      >
      <select
        [(ngModel)]="bulkCancelReasonId"
        class="w-full text-sm rounded-md border border-gray-300 bg-white text-gray-900 dark:bg-gray-800 dark:border-gray-700 dark:text-white px-3 py-2 mb-3"
      >
        @for (r of cancelReasons; track r.id) {
          <option [ngValue]="r.id">{{ r.label || r.name }}</option>
        }
      </select>
      <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1"
        >Notas (opcional)</label
      >
      <textarea
        [(ngModel)]="bulkCancelNotes"
        rows="3"
        class="w-full text-sm rounded-md border border-gray-300 bg-white text-gray-900 placeholder:text-gray-400 dark:bg-gray-800 dark:border-gray-700 dark:text-white px-3 py-2 mb-4"
      ></textarea>
      <div class="flex justify-end gap-2">
        <button
          (click)="closeCancelDialog()"
          class="px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-gray-700"
        >
          Cerrar
        </button>
        <button
          (click)="applyCancelDialog()"
          [disabled]="!bulkCancelReasonId"
          class="px-4 py-2 text-sm rounded-md bg-error-500 text-white disabled:opacity-50"
        >
          {{
            cancelTargetTaskId != null ? 'Cancelar tarea' : 'Cancelar tareas'
          }}
        </button>
      </div>
    </div>
  </div>
}

<!-- El drawer de tarea NO se monta aquí: AppLayout ya monta <app-task-form-drawer />
     globalmente y TaskDrawerService es providedIn:'root'. Montarlo otra vez creaba una
     segunda instancia suscrita al mismo state$ (dos formularios superpuestos). -->

<app-task-detail-modal
  [isOpen]="showDetailModal"
  [taskId]="detailTaskId"
  (closed)="cerrarDetalle()"
  (changed)="onDetailChanged()"
/>
